module.exports = __webpack_public_path__ + "static/img/1.10afe364.jpg";